var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPass2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0001 8.87895C21.9332 7.33687 21.7457 6.33298 21.2204 5.53884C20.9182 5.08196 20.5429 4.68459 20.1113 4.36468C18.9448 3.5 17.2991 3.5 14.0079 3.5H9.99312C6.70185 3.5 5.05621 3.5 3.88969 4.36468C3.45812 4.68459 3.08274 5.08196 2.78054 5.53884C2.25533 6.33289 2.06783 7.33665 2.0009 8.87843C1.98945 9.14208 2.21655 9.34375 2.46538 9.34375C3.85116 9.34375 4.97456 10.533 4.97456 12C4.97456 13.467 3.85116 14.6562 2.46538 14.6562C2.21655 14.6562 1.98945 14.8579 2.0009 15.1216C2.06783 16.6634 2.25533 17.6671 2.78054 18.4612C3.08274 18.918 3.45812 19.3154 3.88969 19.6353C5.05621 20.5 6.70185 20.5 9.99313 20.5H14.0079C17.2991 20.5 18.9448 20.5 20.1113 19.6353C20.5429 19.3154 20.9182 18.918 21.2204 18.4612C21.7457 17.667 21.9332 16.6631 22.0001 15.1211V8.87895Z",
    stroke: "#525252",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 12H17",
    stroke: "#525252",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 16H17",
    stroke: "#525252",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPass2);
export default __webpack_public_path__ + "static/media/pass2.6c5b469eefd81b6edfc393fcd36c66ce.svg";
export { ForwardRef as ReactComponent };